/** Coerce nullable/invalid values to a finite number for currency math. */
export function toAmount(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

/** Safe `.toFixed` for currency display — never throws on null/undefined/NaN. */
export function formatMoney(value, decimals = 2) {
    return toAmount(value).toFixed(decimals);
}

export function combinedAmount(orderLike = {}) {
    return toAmount(orderLike?.total) + toAmount(orderLike?.surcharge) + toAmount(orderLike?.shipping);
}

export function vat18FromCombined(combined) {
    return (toAmount(combined) / 1.18) * 0.18;
}
